import { Zone, ZoneType } from '../../types';
import { ActiveZoneIndicator, ZoneDesc, ZoneImage, ZoneWrapper } from './ZoneItem.styled';
import { MyLocationIcon } from '@medly-components/icons';
import darkBlue from '../../../../theme/colors/darkBlue';
import { Button, Text } from '@medly-components/core';
import { YOU_ARE_HERE } from '../../../../constants/text/myMap';
import Diagnosis from 'assets/images/map/zones/diagnosis.png';
import Treatment from 'assets/images/map/zones/treatment.png';
import Survivorship from 'assets/images/map/zones/active_survivor_ship.png';
import Default from 'assets/images/map/zones/default.png';
import { VIEW } from 'constants/common';

type ZoneItemProps = {
    zone: Zone;
    number: number;
    isActive: boolean;
    onClick?: () => void;
};

interface IZoneItem {
    image: string;
}

const ZoneItemMap: { [key: string]: IZoneItem } = {
    [ZoneType.DIAGNOSIS]: {
        image: Diagnosis
    },
    [ZoneType.TREATMENT]: {
        image: Treatment
    },
    [ZoneType.SURVIVORSHIP]: {
        image: Survivorship
    }
};

export const ZoneItem = ({ zone, number, isActive, onClick = () => {} }: ZoneItemProps) => {
    const { name, description } = zone;

    const zoneItem: IZoneItem | undefined = zone.type ? ZoneItemMap[zone.type] : undefined;
    const zoneImage = zoneItem ? zoneItem.image : Default;

    return (
        <ZoneWrapper onClick={onClick}>
            <ZoneImage src={zoneImage} />
            {isActive && (
                <ActiveZoneIndicator>
                    <MyLocationIcon size="M" variant="flat" iconColor={darkBlue} />
                    <Text textVariant="body2" textColor={darkBlue}>
                        {YOU_ARE_HERE}
                    </Text>
                </ActiveZoneIndicator>
            )}
            <ZoneDesc data-testid={`zone-${number}`}>
                <Text textWeight="Strong" textVariant="h4">
                    {name}
                </Text>
                <Text style={{ marginTop: '0.8rem', flex: '1' }} textVariant="body2">
                    {description ?? ''}
                </Text>
                <Button style={{ width: 'max-content' }}>{VIEW}</Button>
            </ZoneDesc>
        </ZoneWrapper>
    );
};
